<template>
    <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
        <ion-card v-if="show" mode="ios" :disabled="disabled || done">
            <img :src="image"
                 @click="openModal"
                 style="width: 100%; height: auto"/>
            <ion-item>
                <ion-label mode="md" class="ion-text-wrap">
                    <ion-badge v-if="done">
                        <svg class="icon icon-checkmark"><use xlink:href="#icon-checkmark"></use></svg>Test rozwiązany
                    </ion-badge>
                    <p class="text-right text-gray-light"><small>Czas trwania: {{ time }} minut</small></p>
                    <h2>{{ title }}</h2>
                    <!--<p v-html="excerpt"></p>-->
                </ion-label>
            </ion-item>
            <ion-card-content style="text-align:left">
                <ion-button mode="ios"
                            fill="outline"
                            size="small"
                            class="mt-10"
                            @click="openModal"
                            :disabled="disabled || done">Czytaj więcej
                </ion-button>
                <ion-button mode="ios"
                            fill="outline"
                            size="small"
                            class="mt-10"
                            @click="goTo('TrainingSingle', slug)"
                            :disabled="!has_steps || done">Szkolenie
                </ion-button>
                <ion-button mode="ios"
                            fill="outline"
                            size="small"
                            class="mt-10"
                            @click="goTo('TrainingTest', slug)"
                            :disabled="disabled || done">Rozwiąż test
                </ion-button>
            </ion-card-content>
        </ion-card>
    </slide-x-left-transition>
</template>

<script>
    import goTo from '@/mixins/goto';
    import Modal from '@/components/Modal.vue';

    export default {
        name: 'ItemTraining',
        props: ['index', 'slug', 'title', 'excerpt', 'content', 'time', 'image', 'done', 'has_steps', 'disabled'],
        components: { Modal },
        mixins: [goTo],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        },
        methods: {
            openModal(){
                return this.$ionic.modalController.create({
                    component: Modal,
                    mode: 'ios',
                    componentProps: {
                        propsData: {
                            thumbnail: this.image,
                            title: this.title,
                            html: this.content,
                            ctaLabel: 'Przejdź do szkolenia',
                            route: {name: 'TrainingSingle', params: { slug: this.slug }},
                        },
                    },
                }).then(m => m.present())
            },
        }
    }
</script>

<style lang="scss" scoped>
    ion-card{
        margin: 0 0 20px 0px;
        border-radius: 0;
    }
    ion-card-content{
        padding: 0 20px 15px 15px;
    }
</style>